import React from 'react';
import { orderBy, get } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMinusCircle,
  faPlusCircle
} from '@fortawesome/pro-regular-svg-icons';
import { convertISOToDateTimeFormat } from '../../../util/timezone';

export const colGroup = [
  'Total Records',
  'Records Added',
  'Records Changed',
  'Records Deleted'
];

export const recordsLabel = {
  'Total Records': 'Total',
  'Records Added': 'Added',
  'Records Changed': 'Changed',
  'Records Deleted': 'Deleted'
};

export const columnWidth = [75, 178, 120, 290, 99, 120];

export const columnNestedWidth = [63, 64, 68, 59];

export const SerialNumber = 'Serial Number';

export const RecordsCount = 'Records Count';

const getRowStatus = (row) => {
  if (!row['status']) {
    return '-';
  }
  return row['status'] == 'In Production' ? (
    <span
      style={{
        color: '#71C969'
      }}>
      {row['status']}
    </span>
  ) : (
    <span>{row['status']}</span>
  );
};

const renderContent = (value, row, index) => {
  const obj = {
    children: value,
    props: {}
  };
  if (row.id == 'Added' || row.id == 'Deleted') {
    obj.props.colSpan = 0;
  }
  return obj;
};

const renderDate = (value, row, index) => {
  const obj = {
    children: convertISOToDateTimeFormat(value),
    props: {}
  };
  if (row.id == 'Added' || row.id == 'Deleted') {
    obj.props.colSpan = 0;
  }
  return obj;
};

const renderStatus = (_, row, index) => {
  const obj = {
    children: getRowStatus(row),
    props: {}
  };
  if (row.id == 'Added' || row.id == 'Deleted') {
    obj.props.colSpan = 0;
  }
  return obj;
};

const renderNestedColGroup = (_, row, index, childrenItemName) => {
  const obj = {
    children: (
      <div style={{ textAlign: 'right', marginRight: '4px' }}>
        <span>
          {row[childrenItemName]
            ? row[childrenItemName].toLocaleString('en-US')
            : '-'}
        </span>
      </div>
    ),
    props: {}
  };
  if (row.id == 'Added' || row.id == 'Deleted') {
    obj.props.colSpan = 0;
  }
  return obj;
};

const renderWatchlistId = (_, row, index, component, showDrawer) => {
  const obj = {
    children: (
      <span
        style={{
          fontWeight: '500',
          color: '#0c8ed7',
          cursor: 'pointer'
        }}
        onClick={() => {
          if (component === 'watchlist' || component === 'whitelist')
            showDrawer(row);
        }}>
        {row['id']}
      </span>
    ),
    props: {}
  };
  if (row.id == 'Added' || row.id == 'Deleted') {
    obj.props.colSpan = 9;
    obj.props.style = {
      border: '1px solid #D0D7E3',
      background: '#F1F3F4'
    };
    obj.children = (
      <p style={{ margin: 0, padding: 0 }}>
        <FontAwesomeIcon
          icon={row.id == 'Added' ? faPlusCircle : faMinusCircle}
          style={{
            color: row.id == 'Added' ? '#71C969' : '#DF6057',
            fontSize: '14px',
            marginRight: '8px'
          }}
        />
        <span
          style={{
            color: row.id == 'Added' ? '#71C969' : '#DF6057',
            fontSize: '14px',
            fontWeight: '500'
          }}>
          {row['id']}
        </span>
      </p>
    );
  }
  return obj;
};

export const columnParser = (settings, component, showDrawer) => {
  let columns = null;
  if (settings) {
    let sortedSettings = orderBy(settings, ['columnIndex'], ['asc'])
      .filter((column) => column.columnVisibility)
      .filter((column) => column.columnName !== SerialNumber);

    const dataArray = [];
    for (var key in sortedSettings) {
      let obj = {};
      if (
        get(sortedSettings[key], 'columnDetail.0.itemLabel') &&
        colGroup.includes(sortedSettings[key]['columnDetail'][0].itemLabel)
      ) {
        const childrenItemName = get(
          sortedSettings[key],
          'columnDetail.0.itemName'
        );
        if (!dataArray.filter((v) => v['title'] == RecordsCount).length) {
          obj = {
            title: RecordsCount,
            dataIndex: key,
            key,
            children: [
              {
                title: (
                  <div
                    style={{
                      textAlign: 'right',
                      fontWeight: 'normal',
                      margin: '4px'
                    }}>
                    {
                      recordsLabel[
                        sortedSettings[key]['columnDetail'][0].itemLabel
                      ]
                    }
                  </div>
                ),
                dataIndex: childrenItemName,
                key: childrenItemName,
                render: (value, record, index) =>
                  renderNestedColGroup(value, record, index, childrenItemName)
              }
            ]
          };
          dataArray.push(obj);
        } else {
          let objIndex = dataArray.findIndex((v) => v.title == RecordsCount);
          let childrenItem = {
            title: (
              <div
                style={{
                  textAlign: 'right',
                  fontWeight: 'normal',
                  margin: '4px'
                }}>
                {recordsLabel[sortedSettings[key]['columnDetail'][0].itemLabel]}
              </div>
            ),
            dataIndex: childrenItemName,
            key: childrenItemName,
            render: (value, record, index) =>
              renderNestedColGroup(value, record, index, childrenItemName)
          };
          dataArray[objIndex].children.push(childrenItem);
          dataArray[objIndex]?.children.forEach((itemObj, index) => {
            itemObj.width = columnNestedWidth[index];
          });
        }
      } else {
        if (sortedSettings[key]['columnDetail'][0]?.itemName == 'id') {
          obj = {
            ...(sortedSettings[key]['columnDetail'][0] && {
              title: (
                <p style={{ position: 'absolute', top: '9px', left: '9px' }}>
                  {sortedSettings[key]['columnDetail'][0]?.itemLabel}
                </p>
              ),
              dataIndex: sortedSettings[key]['columnDetail'][0]?.itemName,
              key: sortedSettings[key]['columnDetail'][0]?.itemName,
              render: (value, record, index) =>
                renderWatchlistId(value, record, index, component, showDrawer)
            })
          };
        } else if (
          sortedSettings[key]['columnDetail'][0]?.itemName == 'status'
        ) {
          obj = {
            ...(sortedSettings[key]['columnDetail'][0] && {
              title: (
                <p style={{ position: 'absolute', top: '9px', left: '9px' }}>
                  {sortedSettings[key]['columnDetail'][0]?.itemLabel}
                </p>
              ),
              dataIndex: sortedSettings[key]['columnDetail'][0]?.itemName,
              key: sortedSettings[key]['columnDetail'][0]?.itemName,
              render: renderStatus
            })
          };
        } else if (
          sortedSettings[key]['columnDetail'][0]?.itemName == 'createdAt' ||
          sortedSettings[key]['columnDetail'][0]?.itemName == 'updatedAt'
        ) {
          obj = {
            ...(sortedSettings[key]['columnDetail'][0] && {
              title: (
                <p style={{ position: 'absolute', top: '9px', left: '9px' }}>
                  {sortedSettings[key]['columnDetail'][0]?.itemLabel}
                </p>
              ),
              dataIndex: sortedSettings[key]['columnDetail'][0]?.itemName,
              key: sortedSettings[key]['columnDetail'][0]?.itemName,
              render: renderDate
            })
          };
        } else {
          obj = {
            ...(sortedSettings[key]['columnDetail'][0] && {
              title: (
                <p style={{ position: 'absolute', top: '9px', left: '9px' }}>
                  {sortedSettings[key]['columnDetail'][0]?.itemLabel}
                </p>
              ),
              dataIndex: sortedSettings[key]['columnDetail'][0]?.itemName,
              key: sortedSettings[key]['columnDetail'][0]?.itemName,
              render: renderContent
            })
          };
        }
        dataArray.push(obj);
      }
    }
    dataArray.forEach((obj, index) => {
      obj.width = columnWidth[index];
    });
    columns = dataArray;
  }
  return columns;
};
